import { useState, useEffect, useRef } from 'react';
import { Box, Flex, Icon } from '@chakra-ui/react';
import { IoIosHome } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { matchPath, useLocation } from 'react-router';
import { DirectedGraph } from "directed-graph-typed";

import './Styles/Tabs.css'
import { categoriesToHashTable } from '../../utils/Categories Graph/CategoriesArrayToHashTable';
import { extractNameFromCategory } from '../../utils/ExtractInternationalizedKeyFromCategory';

const mapStateToProps = (state) => {
    const categoriesTable = categoriesToHashTable(state.categories)

    return {
        categories: state.categoriesGraph?.outgoingEdgesOf('root').map((edge) => { return categoriesTable[edge.dest] }) || new DirectedGraph(),
        restaurantID: state.restaurantID,
    }    
}


const TabBar = (props) => {
    
    const location = useLocation();
    const [selectedTab, setSelectedTab] = useState('Home');
    const [didSnapToTab, setDidSnapToTab] = useState(false)
    const tabsRefs = useRef([])

    const snapToCategoryTab = (categoryID) => {
        const clickedTab = (tabsRefs.current?.findIndex(
            (ref) => {
                return ref.getAttribute('id') === categoryID
            })
        )

        tabsRefs.current[clickedTab]?.scrollIntoView(
            {
                behavior: "smooth",
                block: 'center',
                inline: 'center'    
            }
        )
    }

    useEffect(() => {

        const URLparams = matchPath(location.pathname, {
            path: "/:id/:categoryID",
            exact: true,
            strict: false
            });

        if (URLparams !== null && URLparams !== undefined) {
            setSelectedTab(URLparams.params.categoryID)
        }

    }, [location]);

    useEffect(()=>{
        if (!!location && !!tabsRefs.current) {
            if (!didSnapToTab) {
                const URLparams = matchPath(location.pathname, {
                    path: "/:id/:categoryID",
                    exact: true,
                    strict: false
                });

                if (!!URLparams) {
                    tabClickHandler(URLparams.params.categoryID)
                }

                setDidSnapToTab(true)
            }
        }
    }, [location, tabsRefs.current])

    useEffect(()=> {
        if (!!props.categories) {
            tabsRefs.current = tabsRefs.current.slice(0, props.categories.length + 1);
        }
    }, [props.categories])

    const tabClickHandler = (tabKey) => {
        setSelectedTab( tabKey );
        snapToCategoryTab(tabKey)
    }

    let tabs = null;

    let selectedTabClass = "tab ripple selected";
    let genericTabClass = "tab ripple";

    if( props.categories ) {
        tabs = props.categories.map( (item, index) => {
            return ( 
                <Box fontSize="md" fontWeight="normal"
                     className={ (item.categoryKey === selectedTab) ? selectedTabClass:genericTabClass} 
                     key={ item["categoryKey"] }
                     onClick={ () => { tabClickHandler( item["categoryKey"] ) } }
                     id={item.categoryKey}
                     ref={el => tabsRefs.current[index+1] = el}
                >
                    <Link to={"/"+props.restaurantID+'/'+item.categoryKey} >
                        { extractNameFromCategory(item) }
                    </Link>   
                </Box>
            )
        });
    }

    return (
        <Box bg="primary" pl="3" color="white" 
                        fontWeight="semibold" fontSize="xl" 
                        position="fixed" bottom="0" 
                        width="100vw" maxWidth="100vw" minHeight="58px" 
                        overflowX="hidden" zIndex="2">

            <Flex height="58px" alignItems="center" overflow="auto" className="noScrollbar">

                <Box height="100%" 
                        className={ (selectedTab === 'Home') ? selectedTabClass:genericTabClass}
                        onClick={ () => {tabClickHandler('Home')} }
                        id="Home"
                        ref={el => tabsRefs.current[0] = el}
                        >
                    <Link to={ "/"+ props.restaurantID+ "/Home" }>
                        <Icon as={IoIosHome} w={6} h={6}/>
                    </Link>   
                </Box>
                
                { tabs }

            </Flex>

        </Box>
    );
} 

export default connect(mapStateToProps)(TabBar);